import * as React from "react";
import * as ReactDOM from "react-dom";
import { onLoad } from "spry-react/utils/onLoad";
import { PortalApp } from "./Shared/portalApp";
import { AppRouterPageResponse } from "./Api/GeneratedDTOs/Api/AppRouterPageResponse";

onLoad((data: AppRouterPageResponse) => {
  ReactDOM.render(
    <PortalApp
      data={data}
      renderChildren={(context) => {
        return <></>;
      }}
      isClientSidePage
    />,
    document.getElementById("root"),
  );
});
